import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { push as updatePath } from 'react-router-redux';
import { all, call, put, spawn, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import Base64Deriver from 'derivers/Base64';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { isEmpty } from 'helpers/verify';
import { msaCreditStatById, plansByMsa, promotionByAlias } from 'redux/saga/entities/bound';
import { getMsa } from 'containers/LocationModal/location.saga';

export const loadCardData = plansModuleConfig => ({
  type: 'PLAN_SELECTION_LOAD_CARD_DATA',
  plansModuleConfig,
});
export const selectPlan = (itemType, itemId) => ({
  type: 'PLAN_SELECTION_SELECT_PLAN',
  itemType,
  itemId,
});

export function* doLoadCreditStat(client, msa) {
  try {
    yield call(fetchEntityIfNeeded, msaCreditStatById, [client, msa.id]);
  } catch (err) {
    logger.warn(`Failed to find credit stat for msa [${msa.id}]`, err);
  }
}

export function* doLoadPlanData(client, msa) {
  try {
    yield call(fetchEntityIfNeeded, plansByMsa, [client, msa.id]);
  } catch (err) {
    logger.warn('Failed to find plans for msa', { msaId: msa.id, err });
  }
}

export function* doLoadPromotionData(client, msa, promotionAlias) {
  try {
    yield call(fetchEntityIfNeeded, promotionByAlias, [client, promotionAlias, msa.id]);
  } catch (err) {
    logger.warn(`Failed to find promotion for alias [${promotionAlias}] in msa [${msa.id}]`, err);
  }
}

export function* doLoadCardData(client, { plansModuleConfig }) {
  const { type: moduleType, promotionAlias } = plansModuleConfig || {};
  const msa = yield call(getMsa, client);

  if (isEmpty(msa)) {
    return;
  }

  yield all(
    [
      call(doLoadCreditStat, client, msa),
      moduleType === 'checkoutPlansModuleType' && call(doLoadPlanData, client, msa),
      moduleType === 'promotionPlansModuleType' && call(doLoadPromotionData, client, msa, promotionAlias),
    ].filter(Boolean)
  );
}

export function* doSelectPlan(client, { itemType, itemId }) {
  if (!itemId || !itemType) {
    return;
  }

  yield spawn(trackOptimizelyEvent, 'successful_plan_selection');
  yield put(updatePath(`/signup/${itemType}/${Base64Deriver.encode(itemId)}`));
}

export function* loadSaga(client, props) {
  yield call(doLoadCardData, client, { plansModuleConfig: props.plansModuleType });
}

export function* watchSaga(client) {
  yield takeEvery(loadCardData().type, doLoadCardData, client);
  yield takeEvery(selectPlan().type, doSelectPlan, client);
}
